import { render, staticRenderFns } from "./checkInfoDialgo.vue?vue&type=template&id=b1d6f08c&scoped=true"
import script from "./checkInfoDialgo.vue?vue&type=script&lang=ts"
export * from "./checkInfoDialgo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6f08c",
  null
  
)

export default component.exports